<template>
    <!-- <div class="form-row">
        <div class="col">Day<input v-model='item.dob_day' type="number" min="01" class="form-control" placeholder="DD"></div>
        <div class="col">Month<input v-model='item.dob_month' type="number" min="1" class="form-control" placeholder="MM"></div>
        <div class="col">Year<input v-model='item.dob_year' type="number" min="1900" class="form-control" placeholder="YYYY"></div>
    </div> -->
    <div :class="'dob-container ' + containerClass">
        <div class="col-6 p-0 m-0">
            <span v-if='showLabels'>{{ $t('translations.day')}}</span>
            <!-- <autocomplete 
                    v-model='day' 
                    class='inputClass' 
                    v-on:change='input($event, 2)'
                    :source='[{id: "00", name: "00"},{id: "01", name: "01"},{id: "02", name: "02"}, {id: "03", name: "03"}]'
                    placeholder='MM'
                    @clear='day = null'></autocomplete> -->
            <input ref='day' data-next='month' v-on:input='inputDay()' v-on:keydown='keyDown($event)' placeholder='DD' type='number' min='1' max='31' v-model="day" :class="inputClass" @blur="onBlur" @focus="onFocus($event)" />
        </div>
        <div class="col-6 p-0 m-0">
            <span v-if='showLabels'>{{ $t('translations.month')}}</span>
            <input ref='month' data-next='year' v-on:input='inputMonth()' v-on:keydown='keyDown($event)' placeholder='MM' type='number' min='1' max='12' v-model="month" :class="inputClass" @blur="onBlur" @focus="onFocus" />
        </div>
        <div class="col-11 p-0 m-0">
            <span v-if='showLabels'>{{ $t('translations.year')}}</span>
            <input ref='year' v-on:input='inputYear()' v-on:keydown='keyDown($event)' placeholder='YYYY' type='number' min='1898' v-model="year" :class="inputClass" @blur="onBlur" @focus="onFocus">
        </div>
    </div>
<!-- <div>
    <div class="d-flex flex-row align-items-top">
        <div class="d-flex flex-column flex-grow: 1">
            <div v-if='showLabels'>Day</div>
            <div class="d-flex flex-row align-items-center">
                <input placeholder='DD' type='number' min='1' max='31' v-model="day" :class="inputClass" @blur="onBlur" @focus="onFocus" />


            </div>
        </div>
        <div style='padding-left: .5em; padding-right: .5em'> / </div>
        <div class="d-flex flex-column flex-grow: 1">
            <div v-if='showLabels'>Month</div>
            <div class="d-flex align-items-center">
                <input placeholder='MM' type='number' min='1' max='12' v-model="month" :class="inputClass" @blur="onBlur" @focus="onFocus" />
                <div style='margin-left: .5em; margin-right: .5em'> / </div>
            </div>
        </div>
        <div class="flex-grow: 2">
            <template v-if='showLabels'>Year</template>
            <input placeholder='YYYY' type='number' min='1900' v-model="year" :class="inputClass" @blur="onBlur" @focus="onFocus">
        </div>
    </div>
</div> -->
</template>

<script>
/**
 * Code taken from the vue-dob-picker: https://danielbrierton.github.io/vue-dob-picker/
 * and modified to use text input fields with auto focus. Note that the month
 * index is now 1 based (it was 0 based in the original as it used a select)
 * list.
 */
const datesInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export default {
    name: 'vue-dob-picker',
    props: {
        value: {

        },
        inputClass: {
            type: String,
            default: "form-control nospin"
        },
        containerClass: {
            type: String,
            default: "d-flex justify-content-between",
        },
        showLabels: String,
        locale: {
            type: String,
            default: navigator.language,
        },
        monthFormat: {
            type: String,
            default: '2-digit',
        },
        proportions: {
            type: Array,
            default: () => [1, 1, 2],
        },
        labels: {
            type: Array,
            default: () => ['Date', 'Month', 'Year'],
        },
        placeholders: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            day: null,
            month: null,
            year: null,
            currentYear: (new Date()).getFullYear(),
            blurTimeout: null,
        };
    },
    computed: {
        date: {
            get() {
                // console.log("date getter called: " + this.year + "-" + this.month + "-" + this.day);
                // console.log("isLeapYear: " + this.isLeapYear + ": " + this.isLeapYear);
                let daysInMonth = this.daysInMonth;
                // console.log("daysInMonth(1): " + daysInMonth);
                // console.log("month: " + this.month);
                if (this.isLeapYear && this.month == 2) {
                    daysInMonth += 1;
                }
                // console.log("daysInMonth(2): " + daysInMonth);
                if (this.day > daysInMonth) {
                    this.day = daysInMonth;
                }
                if (this.day !== null && ("" + this.day).match(/^(0?[1-9]|[12][0-9]|3[0-1])$/) && this.month !== null && ("" + this.month).match(/^(0?[1-9]|[1][0-2])$/) && this.year !== null && ("" + this.year).match(/^[0-9]{4}$/)) {
                    return new Date(this.year, this.month - 1, this.day, 0, 0, 0, 0);
                    //return "" + this.year + "-" + this.month + "-" + this.day;
                }
                return null;
            },
            set(val) {
                if (val) {
                    // We check the values using parseInt so that we don't reset the values
                    // when they are just 0 padded by the date functions.
                    if(parseInt(this.day) != parseInt(("" + val.getDate()).slice(-2))) {
                        this.day = ("0" + (val.getDate())).slice(-2);
                    }
                    if(parseInt(this.month) != parseInt(("" + val.getMonth() + 1).slice(-2))) {
                        this.month = ("0" + (val.getMonth() + 1)).slice(-2);
                    }
                    if(parseInt(this.day) != parseInt(val.getFullYear())) {
                        this.year = val.getFullYear();
                    }
                }

            },
        },
        daysInMonth() {
            return datesInMonths[this.month - 1] || 31;
        },
        isLeapYear() {
            if(("" + this.year).match(/[0-9]{4}/)) {
                return ((this.year % 4 === 0) && (this.year % 100 !== 0)) || (this.year % 400 === 0);
            }
            // If we haven't got a full YYYY year yet, assume it is a leap year
            return true;
        },
    },
    watch: {
        date() {
            // console.log("Date has changed to: " + this.date);
            if (this.date) {
                this.$emit('input', this.year + "-" + this.month + "-" + this.day);
                this.$emit('change', {index: this.$el.dataset.index, value: this.year + "-" + this.month + "-" + this.day});
            }
            else {
                this.$emit('change-invalid');
            }
        },
        value() {
            this.setDateFromValue();
        },
        // day() {
        //     var pad = false;
        //     if(this.day > 0) {
        //         console.info(("" + this.day).charAt(0));
        //         if(("" + this.day).charAt(0) == '0') {
        //             pad = true;
        //         }
        //         this.day = parseInt(this.day);
                
        //         if(pad) {
        //             this.day = ("" + this.day).padStart(2, 0);
        //         }
        //         if(this.day == '00') {
        //             this.day = "";
        //         }
        //     }
        // }
    },
    mounted() {
        this.setDateFromValue();
    },
    methods: {
        setDateFromValue() {
            // console.log("Value has changed to: " + this.value);
            if(this.value && this.value.match(/[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/)) {
                var parts = this.value.split("-");
                var newDate = new Date(parts[0], parts[1] - 1, parts[2]);

                if(newDate instanceof Date && !isNaN(newDate) && +newDate != +Date) {
                    this.date = newDate;
                }
            }
            else {
                this.day = this.month = this.year = "";
            }
        },
        getDisplayedMonth(monthNum) {
            const monthDateObj = new Date(2000, monthNum, 1);
            const locale = this.locale || navigator.language;
            return monthDateObj.toLocaleString(locale, {
                month: this.monthFormat
            });
        },
        onBlur() {
            this.blurTimeout = window.setTimeout(() => {
                this.$emit('blur');
            }, 50);
        },
        onFocus(event) {
            window.clearTimeout(this.blurTimeout);
            event.target.select();
        },
        keyDown(event) {
            if(event.key && event.key.length == 1 && (event.key < "0" || event.key > "9")) {
                return event.preventDefault();
            }
        },
        inputDay(event) {
            if(this.day.length > 2 ) {
                this.day = this.day.substr(1);
                //return event.preventDefault();
            }
            if(this.day.length == 2) {
                Vue.nextTick(() => {this.$refs["month"].focus()});
            }    
        },
        inputMonth(event) {
            if(this.month < 0) {
                this.month = 1;
            }
            if(this.month > 12) {
                this.month = 12;
            }
            if(this.month.length > 2 ) {
                this.month = this.month.substr(1);
                //return event.preventDefault();
            }
            if(this.month.length == 2) {
                Vue.nextTick(() => {this.$refs["year"].focus()});
            }
            
        },
        inputYear(event) {
            if(this.year < 0) {
                this.year = 0;
            }
            if(this.year > this.moment().year()) {
                this.year = this.moment().year();
            }
            if(this.year.length > 4 ) {
                this.year = this.year.substr(1);
                //return event.preventDefault();
            }
            
        },
        getAge() {
            return this.moment().diff(value, 'years', false);
        }
    },
};
</script>

<style scoped>
.vue-dob-picker {
    display: flex;
}

label {
    display: inline-block;
    padding: 0 4px;
}

label:first-child {
    padding-left: 0;
}

label:last-child {
    padding-right: 0;
}

input[type='number'].nospin {
    -moz-appearance: textfield;
}

input::-webkit-outer-spin-button.nospin,
input::-webkit-inner-spin-button.nospin {
    -webkit-appearance: none;
}
</style>
